import { render, staticRenderFns } from "./UserPointDetail.vue?vue&type=template&id=17a86f0e"
import script from "./UserPointDetail.vue?vue&type=script&lang=js"
export * from "./UserPointDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports